module.exports = __webpack_public_path__ + "img/safe-logo.36b5d7b7.svg";